import JSZip from "jszip";
import PropTypes from "prop-types";
import React from "react";
import { Button } from "reactstrap";

import { useAppDispatch } from "../../../src/ReduxToolkit/Hooks";
import { MUIIcons } from "../../AbstractElements";
import CommonModal from "../../CommonElements/Modal";
import { updateCourseStatus } from "../../ReduxToolkit/Reducers/CourseSlice";
import { requestWBTReattempt } from "../../ReduxToolkit/Reducers/CourseSlice";
import {
  getScormData,
  setScormToInitialValues,
} from "../../ReduxToolkit/Reducers/LearnerSlice";
import {
  Confirm,
  RaiseWBTReattempt,
  RaiseWBTReattemptHeader,
  RequestForAttempt,
  StartLearningNow,
} from "../../utils/Constant";
import { showToast } from "../../utils/helper/helper";
import {
  saveToLocalStorage,
  OPENED_SCORM_DETAILS,
  LEARNING_PLAN_DETAILS,
} from "../../utils/helper/localStorageutils";
import { currentUserId } from "../../utils/helper/permission";

const PlayCourseMaterial = ({
  material,
  courseId,
  courseName,
  learningPlanCompletionId = null,
  course_detail = null,
}) => {
  const dispatch = useAppDispatch();
  const [showRequestModal, setShowRequestModal] = React.useState(false);

  const onPlayFile = async (scormPackagePath: string) => {
    try {
      const scormResponse: any = await dispatch(
        getScormData({ courseId: courseId.toString() })
      );
      if (
        scormResponse &&
        scormResponse?.error &&
        scormResponse?.error?.message
      ) {
        const parsedResponse = JSON.parse(scormResponse?.error?.message);
        const message = parsedResponse.message;
        showToast(message, "error");
        return;
      }
      saveToLocalStorage(LEARNING_PLAN_DETAILS, learningPlanCompletionId);
      saveToLocalStorage(OPENED_SCORM_DETAILS, {});
      if (scormPackagePath.includes(".zip")) {
        const response = await fetch(scormPackagePath);
        const blob = await response.blob();
        const zip = await JSZip.loadAsync(blob);
        const files = [];
        zip.forEach((relativePath, file) => {
          files.push({ path: relativePath, file });
        });
        const indexFile = files.find(
          f =>
            f.path.endsWith("index.html") || f.path.endsWith("launchpage.html")
        );
        if (indexFile) {
          const content = await indexFile.file.async("string");
          const blob = new Blob([content], { type: "text/html" });
          const url = URL.createObjectURL(blob);
          const width = 1400;
          const height = 700;
          const left = window.screen.width / 2 - width / 2;
          const top = window.screen.height / 2 - height / 2;
          if (scormResponse?.payload?.data?.scorm_data) {
            const scormData = scormResponse.payload.data;
            let updatedScormData = { ...scormData, course_name: courseName };
            if (scormResponse?.payload?.data?.scorm_attempt_id) {
              updatedScormData = {
                ...updatedScormData,
                scorm_attempt_id:
                  scormResponse?.payload?.data?.scorm_attempt_id,
              };
            }
            saveToLocalStorage(OPENED_SCORM_DETAILS, updatedScormData);
          } else {
            const newPayload = {
              course_name: courseName,
              course_id: courseId.toString(),
              scorm_data: {},
              ...(scormResponse?.payload?.data?.scorm_attempt_id && {
                scorm_attempt_id: scormResponse.payload.data.scorm_attempt_id,
              }),
            };

            saveToLocalStorage(OPENED_SCORM_DETAILS, newPayload);
          }
          window.open(
            url,
            "_blank",
            `width=${width},height=${height},top=${top},left=${left}`
          );
        }
      }
      const payload = {
        course_id: courseId.toString(),
        user_id: currentUserId(),
        status: "in_progress",
        type: "ilp",
      };

      const lpPayload = {
        learning_plan_completion_id: parseInt(learningPlanCompletionId),
        user_id: currentUserId(),
        status: "in_progress",
        type: "learning_plan",
      };

      await dispatch(
        updateCourseStatus({
          courseStatus:
            learningPlanCompletionId &&
            learningPlanCompletionId !== "" &&
            learningPlanCompletionId !== null &&
            learningPlanCompletionId !== "null"
              ? lpPayload
              : payload,
        })
      );
    } catch (e) {
      dispatch(setScormToInitialValues());
      saveToLocalStorage(OPENED_SCORM_DETAILS, {});
    }
  };

  const onRequestAttempt = () => {
    setShowRequestModal(true);
  };

  const handleRequestConfirm = async () => {
    await dispatch(
      requestWBTReattempt({ course_id: courseId, type: "wbt-attempt" })
    );
    setShowRequestModal(false);
  };

  const handleRequestCancel = () => {
    setShowRequestModal(false);
  };

  return (
    <>
      {course_detail?.wbt_attempts?.max_attempt -
        (course_detail?.wbt_attempts?.attempts?.filter?.(
          a => a.status === "completed"
        )?.length || 0) >
        0 || !course_detail?.wbt_is_launch ? (
        <Button
          onClick={() => onPlayFile(material.file_url)}
          color="primary"
          className="d-flex align-items-center gap-1 w-100 mt-3 justify-content-center"
        >
          <MUIIcons size={24} iconName="PlayCircleFilledWhiteOutlined" />
          {StartLearningNow}
        </Button>
      ) : (
        <Button
          onClick={onRequestAttempt}
          color="primary"
          className="d-flex align-items-center gap-1 w-100 mt-3 justify-content-center"
        >
          <MUIIcons size={24} iconName="PlayCircleFilledWhiteOutlined" />
          {RequestForAttempt}
        </Button>
      )}
      <CommonModal
        isOpen={showRequestModal}
        toggle={handleRequestCancel}
        title={RaiseWBTReattemptHeader}
        showFooter
        primaryBtnText={Confirm}
        onPrimaryBtnClick={handleRequestConfirm}
      >
        {RaiseWBTReattempt}
      </CommonModal>
    </>
  );
};

PlayCourseMaterial.propTypes = {
  material: PropTypes.object,
  courseId: PropTypes.number,
  courseName: PropTypes.string,
  learningPlanCompletionId: PropTypes.any,
  course_detail: PropTypes.any,
};

export default PlayCourseMaterial;
